import { useState, useEffect } from "react";
import { supabase } from "../supabase";
import { C } from "../lib/constants";
import { adaptSupervisor } from "../lib/helpers";
import { FICIO_DIRECTORY_CACHE } from "../lib/cache";
import { Stars } from "./ui/Stars";
import { Btn } from "./ui/Btn";
import { Av } from "./ui/Av";
import { Chip } from "./ui/Chip";
import { TopNav } from "./ui/TopNav";
import { Bar } from "./WorkerProfile";

// FIX F1-4: firma extendida para recibir user, profile y setScreen que App pasa.
export const SupervisionFlow = ({ user, profile, setScreen }) => { // eslint-disable-line no-unused-vars
  // TODOS los hooks al inicio — Rules of Hooks
  const [step,          setStep]          = useState("list");
  const [selected,      setSelSup]        = useState(null);
  const [supervisorsDB, setSupervisorsDB] = useState(() => FICIO_DIRECTORY_CACHE.supervisors || []);
  const [msgs,       setMsgs]       = useState([
    {from:"sup", text:"Hola, recibí tu solicitud. ¿Cuál es la dirección exacta de la obra?", time:"10:02"},
  ]);
  const [input,      setInput]      = useState("");
  const [reportTxt,  setReportTxt]  = useState("");
  const [avance,     setAvance]     = useState("");
  const [dictamen,   setDictamen]   = useState("");
  const [fotos,      setFotos]      = useState([false,false,false]);
  const [checklist,  setChecklist]  = useState({nivelacion:null,acabados:null,materiales:null,seguridad:null,limpieza:null,instalaciones:null});
  const [supFirmado, setSupFirmado] = useState(false);
  const [reportDone, setReportDone] = useState(false);

  useEffect(() => {
    const cargarSupervisores = async () => {
      const { data, error } = await supabase
        .from("supervisores")
        .select("*")
        .order("created_at", { ascending: false });
      if (error) { console.warn("Error supervisores:", error.message); setSupervisorsDB([]); return; }
      setSupervisorsDB((data || []).map(adaptSupervisor));
    };
    cargarSupervisores();
  }, []);

  const sendMsg = () => {
    if(!input.trim()) return;
    setMsgs(m=>[...m,{from:"me",text:input.trim(),time:"Ahora"}]);
    setInput("");
    setTimeout(()=>setMsgs(m=>[...m,{from:"sup",text:"Perfecto, agendo la visita para mañana a las 9am. Te confirmo dentro de Ficio.",time:"Ahora"}]),1200);
  };

  // ── LIST ──
  if(step==="list") return (
    <div>
      <div style={{background:C.blueL,border:`1.5px solid ${C.blue}30`,borderRadius:14,padding:"14px 16px",marginBottom:8}}>
        <div style={{color:C.blue,fontWeight:700,fontSize:13,marginBottom:4}}>🏗️ Supervisión Profesional</div>
        <div style={{color:C.sub,fontSize:13}}>Un ingeniero o arquitecto revisa el trabajo en sitio. <strong style={{color:C.text}}>$499 por visita.</strong></div>
      </div>
      <div style={{background:"#FFFDE7",border:`1px solid #F9A82540`,borderRadius:12,padding:"10px 14px",marginBottom:14,display:"flex",gap:8,alignItems:"flex-start"}}>
        <span style={{fontSize:16}}>🔒</span>
        <div style={{color:"#795548",fontSize:12,lineHeight:1.5}}>El contacto con el supervisor ocurre <strong>únicamente dentro de Ficio</strong>. El número personal nunca se comparte. Todo queda documentado.</div>
      </div>
      <div style={{display:"flex",flexDirection:"column",gap:12}}>
        {supervisorsDB.map(s=>(
          <div key={s.id} style={{background:C.surface,border:`1.5px solid ${C.border}`,borderRadius:18,padding:"18px",boxShadow:"0 2px 8px rgba(0,0,0,0.04)",cursor:s.available?"pointer":"default",transition:"all 0.2s"}}
            onMouseEnter={e=>{if(s.available){e.currentTarget.style.borderColor=s.color;e.currentTarget.style.boxShadow=`0 6px 20px ${s.color}20`;}}}
            onMouseLeave={e=>{e.currentTarget.style.borderColor=C.border;e.currentTarget.style.boxShadow="0 2px 8px rgba(0,0,0,0.04)";}}>
            <div style={{display:"flex",gap:14,alignItems:"flex-start"}}>
              <Av letters={s.avatar} color={s.color} size={52} dot={s.available}/>
              <div style={{flex:1}}>
                <div style={{fontFamily:"'Georgia',serif",fontSize:15,fontWeight:800,color:C.text,marginBottom:2}}>{s.name}</div>
                <div style={{color:s.color,fontSize:12,fontWeight:600,marginBottom:8}}>{s.specialty}</div>
                <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:12}}>
                  <Stars rating={s.rating}/><span style={{color:C.muted,fontSize:11}}>{s.reviews} supervisiones · {s.exp} años</span>
                </div>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                    <Chip text="Cédula SEP ✓" color={C.blue} small/>
                    <Chip text="Chat interno" color={C.green} small/>
                    <Chip text="Reporte oficial" color={s.color} small/>
                  </div>
                  <div style={{display:"flex",gap:8,alignItems:"center"}}>
                    <span style={{fontFamily:"'Georgia',serif",fontWeight:800,color:C.accent,fontSize:20}}>${s.price}</span>
                    <Btn small color={s.available?s.color:"#CCC"} onClick={()=>{if(s.available){setSelSup(s);setStep("detail");}}}>{s.available?"Ver perfil":"Ocupado"}</Btn>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  // ── DETAIL ──
  if(step==="detail" && selected) return (
    <div>
      <TopNav setScreen={()=>{}} back={()=>setStep("list")} backLabel="Supervisores" title="Perfil del Supervisor"/>
      <div style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:18,padding:20,marginBottom:14,boxShadow:"0 2px 8px rgba(0,0,0,0.04)"}}>
        <div style={{display:"flex",gap:14,alignItems:"flex-start",marginBottom:16}}>
          <Av letters={selected.avatar} color={selected.color} size={64} dot={selected.available}/>
          <div style={{flex:1}}>
            <div style={{fontFamily:"'Georgia',serif",fontSize:18,fontWeight:800,color:C.text,marginBottom:3}}>{selected.name}</div>
            <div style={{color:selected.color,fontSize:13,fontWeight:600,marginBottom:6}}>{selected.specialty}</div>
            <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
              <Chip text="Cédula SEP Verificada" color={C.blue}/>
              <Chip text={`${selected.exp} años exp.`} color={selected.color} small/>
            </div>
          </div>
        </div>
        <Stars rating={selected.rating}/>
        <div style={{color:C.muted,fontSize:12,marginTop:4,marginBottom:16}}>{selected.reviews} supervisiones realizadas</div>
        {[["Calidad del reporte","4.9"],["Puntualidad","4.8"],["Claridad técnica","4.9"],["Trato profesional","5.0"]].map(([k,v])=>(
          <Bar key={k} label={k} value={parseFloat(v)} color={selected.color}/>
        ))}
      </div>
      <div style={{background:"#FFFDE7",border:`1px solid #F9A82540`,borderRadius:12,padding:"12px 16px",marginBottom:16}}>
        <div style={{fontWeight:700,fontSize:13,color:"#795548",marginBottom:8}}>🔒 ¿Cómo funciona la supervisión en Ficio?</div>
        {["Pagas dentro de la app — el supervisor nunca ve tu tarjeta","El chat es exclusivo de Ficio — no se intercambian números","Al terminar, el supervisor sube el reporte oficial desde la app","El reporte queda en tu historial permanentemente","Si contratas fuera de Ficio pierdes el respaldo y el documento"].map(t=>(
          <div key={t} style={{display:"flex",gap:8,marginBottom:6}}><span style={{color:C.green,fontWeight:700}}>✓</span><span style={{color:"#795548",fontSize:12}}>{t}</span></div>
        ))}
      </div>
      <div style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:14,padding:16,marginBottom:16,boxShadow:"0 2px 6px rgba(0,0,0,0.04)"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:4}}>
          <span style={{color:C.sub,fontSize:13}}>Supervisión en sitio</span>
          <span style={{fontFamily:"'Georgia',serif",fontWeight:800,color:C.text,fontSize:20}}>$500</span>
        </div>
        <div style={{color:C.muted,fontSize:11}}>Incluye visita · Reporte oficial · Chat interno · Historial documentado</div>
      </div>
      <Btn full color={selected.color} onClick={()=>setStep("pago")}>Contratar supervisión — $500 →</Btn>
    </div>
  );

  // ── PAGO ──
  if(step==="pago") return (
    <div>
      <TopNav setScreen={()=>{}} back={()=>setStep("detail")} backLabel="Perfil" title="Confirmar pago"/>
      <div style={{fontFamily:"'Georgia',serif",fontSize:22,fontWeight:800,color:C.text,marginBottom:4}}>Confirmar pago</div>
      <div style={{color:C.muted,fontSize:13,marginBottom:20}}>El supervisor es notificado automáticamente al confirmar.</div>
      <div style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:16,padding:18,marginBottom:16,boxShadow:"0 2px 6px rgba(0,0,0,0.04)"}}>
        <div style={{display:"flex",justifyContent:"space-between",marginBottom:10,paddingBottom:10,borderBottom:`1px solid ${C.divider}`}}>
          <span style={{color:C.sub,fontSize:13}}>Supervisor</span>
          <span style={{color:C.text,fontSize:13,fontWeight:700}}>{selected?.name}</span>
        </div>
        <div style={{display:"flex",justifyContent:"space-between",marginBottom:10,paddingBottom:10,borderBottom:`1px solid ${C.divider}`}}>
          <span style={{color:C.sub,fontSize:13}}>Servicio</span>
          <span style={{color:C.text,fontSize:13,fontWeight:700}}>Visita de supervisión</span>
        </div>
        <div style={{display:"flex",justifyContent:"space-between",marginBottom:10,paddingBottom:10,borderBottom:`1px solid ${C.divider}`}}>
          <span style={{color:C.sub,fontSize:13}}>Va al supervisor</span>
          <span style={{color:C.green,fontSize:13,fontWeight:700}}>$350</span>
        </div>
        <div style={{display:"flex",justifyContent:"space-between",marginBottom:10,paddingBottom:10,borderBottom:`1px solid ${C.divider}`}}>
          <span style={{color:C.sub,fontSize:13}}>Plataforma Ficio</span>
          <span style={{color:C.blue,fontSize:13,fontWeight:700}}>$150</span>
        </div>
        <div style={{display:"flex",justifyContent:"space-between"}}>
          <span style={{color:C.text,fontSize:15,fontWeight:700}}>Total</span>
          <span style={{fontFamily:"'Georgia',serif",fontSize:22,fontWeight:900,color:C.accent}}>$500</span>
        </div>
      </div>
      <div style={{display:"flex",flexDirection:"column",gap:10,marginBottom:16}}>
        {[{icon:"💳",label:"Tarjeta de crédito / débito"},{icon:"📱",label:"Mercado Pago"},{icon:"🏦",label:"Transferencia bancaria"}].map(p=>(
          <div key={p.label} style={{background:C.surface,border:`1.5px solid ${C.border}`,borderRadius:12,padding:"14px 16px",display:"flex",alignItems:"center",gap:12,cursor:"pointer",transition:"all 0.15s"}}
            onMouseEnter={e=>e.currentTarget.style.borderColor=C.blue}
            onMouseLeave={e=>e.currentTarget.style.borderColor=C.border}>
            <span style={{fontSize:22}}>{p.icon}</span>
            <span style={{color:C.text,fontSize:14,fontWeight:600}}>{p.label}</span>
          </div>
        ))}
      </div>
      <div style={{background:"#FFFDE7",border:`1px solid #F9A82540`,borderRadius:12,padding:"10px 14px",marginBottom:16,display:"flex",gap:8}}>
        <span>🔒</span>
        <span style={{color:"#795548",fontSize:12}}>Pago seguro. El supervisor NO recibe tus datos bancarios. Solo Ficio procesa el cobro.</span>
      </div>
      <Btn full color={C.blue} onClick={()=>setStep("chat")}>Confirmar y pagar $500</Btn>
    </div>
  );

  // ── CHAT ──
  if(step==="chat") return (
    <div>
      <TopNav setScreen={()=>{}} back={()=>setStep("pago")} backLabel="Pago" title="Chat de supervisión"/>
      <div style={{background:C.surface,borderBottom:`1px solid ${C.border}`,borderRadius:"14px 14px 0 0",padding:"14px 16px",display:"flex",alignItems:"center",gap:12,marginBottom:0}}>
        <Av letters={selected?.avatar||"JM"} color={selected?.color||C.blue} size={40}/>
        <div style={{flex:1}}>
          <div style={{fontFamily:"'Georgia',serif",fontSize:14,fontWeight:800,color:C.text}}>{selected?.name}</div>
          <div style={{color:C.green,fontSize:11,fontWeight:600}}>● En línea · Supervisión confirmada</div>
        </div>
        <div style={{background:"#FFFDE7",borderRadius:8,padding:"4px 10px"}}>
          <span style={{color:"#795548",fontSize:10,fontWeight:700}}>🔒 Chat seguro</span>
        </div>
      </div>
      <div style={{background:"#FFFDE7",border:`1px solid #F9A82540`,borderRadius:0,padding:"8px 16px",marginBottom:0}}>
        <span style={{color:"#795548",fontSize:11}}>⚠️ Por seguridad y para mantener tu respaldo, no compartas ni solicites datos de contacto fuera de Ficio.</span>
      </div>
      <div style={{background:C.bg,minHeight:280,padding:"14px 16px",display:"flex",flexDirection:"column",gap:10,border:`1px solid ${C.border}`,borderTop:"none"}}>
        {msgs.map((m,i)=>(
          <div key={i} style={{display:"flex",justifyContent:m.from==="me"?"flex-end":"flex-start"}}>
            <div style={{background:m.from==="me"?C.blue:C.surface,color:m.from==="me"?"#fff":C.text,borderRadius:m.from==="me"?"16px 16px 4px 16px":"16px 16px 16px 4px",padding:"10px 14px",maxWidth:"75%",fontSize:13,lineHeight:1.5,border:m.from==="me"?"none":`1px solid ${C.border}`,boxShadow:"0 1px 4px rgba(0,0,0,0.06)"}}>
              {m.text}
              <div style={{fontSize:9,opacity:0.6,marginTop:4,textAlign:"right"}}>{m.time}</div>
            </div>
          </div>
        ))}
      </div>
      <div style={{background:C.surface,border:`1px solid ${C.border}`,borderTop:"none",borderRadius:"0 0 14px 14px",padding:"12px 14px",display:"flex",gap:10}}>
        <input value={input} onChange={e=>setInput(e.target.value)} onKeyDown={e=>e.key==="Enter"&&sendMsg()} placeholder="Escribe un mensaje..."
          style={{flex:1,background:C.bg,border:`1.5px solid ${C.border}`,borderRadius:10,padding:"10px 14px",fontSize:13,outline:"none",fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",color:C.text}}
          onFocus={e=>e.target.style.borderColor=C.blue} onBlur={e=>e.target.style.borderColor=C.border}/>
        <button onClick={sendMsg} style={{background:C.blue,border:"none",borderRadius:10,color:"#fff",padding:"10px 16px",cursor:"pointer",fontWeight:700,fontSize:14}}>→</button>
      </div>
      <div style={{marginTop:14}}>
        <Btn full color={C.green} onClick={()=>setStep("reporte")}>📋 La visita se realizó · Subir reporte</Btn>
      </div>
    </div>
  );

  // ── REPORTE ──
  if(step==="reporte") return (
    <div style={{paddingBottom:20}}>
      <TopNav setScreen={()=>{}} back={()=>setStep("chat")} backLabel="Chat" title="Reporte oficial"/>

      {/* Folio y encabezado */}
      <div style={{background:`linear-gradient(135deg,${C.blue},#1A3D7C)`,borderRadius:16,padding:"16px 18px",marginBottom:16,color:"#fff"}}>
        <div style={{fontSize:10,fontWeight:700,letterSpacing:1.5,textTransform:"uppercase",opacity:0.7,marginBottom:4}}>Reporte Oficial Ficio</div>
        <div style={{fontFamily:"'Georgia',serif",fontSize:20,fontWeight:800,marginBottom:2}}>Supervisión Técnica de Obra</div>
        <div style={{fontSize:11,opacity:0.8}}>Folio: FIC-2026-0429-001 · {selected?.name}</div>
      </div>

      {reportDone ? (
        // ── REPORTE CERRADO ──
        <div style={{textAlign:"center",padding:"24px 0"}}>
          <div style={{fontSize:64,marginBottom:12}}>📋</div>
          <div style={{fontFamily:"'Georgia',serif",fontSize:22,fontWeight:800,color:C.green,marginBottom:8}}>Reporte válido y cerrado</div>
          <div style={{color:C.sub,fontSize:13,lineHeight:1.6,marginBottom:20}}>Firmado por el supervisor y validado por el cliente. Queda en el historial permanente de Ficio. No puede modificarse.</div>
          <div style={{background:C.greenL,border:`1.5px solid ${C.green}30`,borderRadius:14,padding:16,marginBottom:20,textAlign:"left"}}>
            {[["✍️ Supervisor",selected?.name],["👤 Cliente","Cliente Ficio"],["📅 Fecha",new Date().toLocaleDateString("es-MX",{day:"2-digit",month:"short",year:"numeric"})],["📋 Folio",`FIC-${Date.now().toString(36).toUpperCase().slice(-8)}`],["✅ Estado","Válido · Firmado por ambas partes"]].map(([k,v])=>(
              <div key={k} style={{display:"flex",justifyContent:"space-between",marginBottom:6,paddingBottom:6,borderBottom:`1px solid ${C.green}20`}}>
                <span style={{color:C.sub,fontSize:12}}>{k}</span>
                <span style={{color:C.text,fontSize:12,fontWeight:700}}>{v}</span>
              </div>
            ))}
          </div>
          <Btn full color={C.green} onClick={()=>{setStep("list");setReportDone(false);setSupFirmado(false);setReportTxt("");setAvance("");setDictamen("");setFotos([false,false,false]);setChecklist({nivelacion:null,acabados:null,materiales:null,seguridad:null,limpieza:null,instalaciones:null});setMsgs([{from:"sup",text:"Hola, recibí tu solicitud. ¿Cuál es la dirección exacta de la obra?",time:"10:02"}]);}}>Finalizar supervisión</Btn>
        </div>
      ) : !supFirmado ? (
        // ── PASO 1: SUPERVISOR LLENA Y FIRMA ──
        <>
          <div style={{background:C.blueL,border:`1.5px solid ${C.blue}30`,borderRadius:12,padding:"10px 14px",marginBottom:16,display:"flex",gap:8,alignItems:"center"}}>
            <span style={{fontSize:16}}>✍️</span>
            <div>
              <div style={{color:C.blue,fontWeight:700,fontSize:12}}>Paso 1 de 2 — Firma del Supervisor</div>
              <div style={{color:C.sub,fontSize:11}}>Solo el supervisor puede completar y firmar este reporte.</div>
            </div>
          </div>

          {/* Info de la visita */}
          <div style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:14,padding:16,marginBottom:14,boxShadow:"0 2px 6px rgba(0,0,0,0.04)"}}>
            <div style={{color:C.sub,fontSize:11,fontWeight:700,letterSpacing:0.8,textTransform:"uppercase",marginBottom:12}}>📍 Datos de la visita</div>
            {[["Supervisor",selected?.name||"Supervisor Ficio"],["Cédula SEP",selected?.cedula||"SEP verificada"],["Fecha",new Date().toLocaleDateString("es-MX",{weekday:"long",day:"2-digit",month:"long",year:"numeric"})],["Obra","Según solicitud activa"],["Trabajador","Trabajador Ficio"],["Cliente","Cliente Ficio"]].map(([k,v])=>(
              <div key={k} style={{display:"flex",gap:12,marginBottom:8,paddingBottom:8,borderBottom:`1px solid ${C.divider}`}}>
                <span style={{color:C.muted,fontSize:12,minWidth:120}}>{k}</span>
                <span style={{color:C.text,fontSize:12,fontWeight:600}}>{v}</span>
              </div>
            ))}
          </div>

          {/* Porcentaje de avance */}
          <div style={{marginBottom:14}}>
            <div style={{color:C.sub,fontSize:11,fontWeight:700,letterSpacing:0.8,textTransform:"uppercase",marginBottom:8}}>📊 Porcentaje de avance</div>
            <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
              {["25%","50%","75%","90%","100%"].map(p=>(
                <button key={p} onClick={()=>setAvance(p)} style={{background:avance===p?C.blue:C.surface,border:`1.5px solid ${avance===p?C.blue:C.border}`,borderRadius:10,padding:"8px 16px",color:avance===p?"#fff":C.sub,fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif"}}>{p}</button>
              ))}
            </div>
          </div>

          {/* Checklist técnico */}
          <div style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:14,padding:16,marginBottom:14,boxShadow:"0 2px 6px rgba(0,0,0,0.04)"}}>
            <div style={{color:C.sub,fontSize:11,fontWeight:700,letterSpacing:0.8,textTransform:"uppercase",marginBottom:12}}>✅ Checklist técnico</div>
            {[["nivelacion","Nivelación y trazo"],["acabados","Acabados superficiales"],["materiales","Materiales conforme a especificación"],["seguridad","Condiciones de seguridad"],["limpieza","Limpieza del área de trabajo"],["instalaciones","Instalaciones (si aplica)"]].map(([key,label])=>(
              <div key={key} style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10,paddingBottom:10,borderBottom:`1px solid ${C.divider}`}}>
                <span style={{color:C.text,fontSize:13}}>{label}</span>
                <div style={{display:"flex",gap:6}}>
                  {[["✓","ok",C.green],["⚠️","obs","#F57F17"],["✗","mal",C.red]].map(([icon,val,color])=>(
                    <button key={val} onClick={()=>setChecklist(c=>({...c,[key]:val}))}
                      style={{background:checklist[key]===val?color:C.faint,border:`1.5px solid ${checklist[key]===val?color:C.border}`,borderRadius:8,width:34,height:34,cursor:"pointer",fontSize:14,display:"flex",alignItems:"center",justifyContent:"center",transition:"all 0.15s"}}>
                      {icon}
                    </button>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Observaciones */}
          <div style={{marginBottom:14}}>
            <div style={{color:C.sub,fontSize:11,fontWeight:700,letterSpacing:0.8,textTransform:"uppercase",marginBottom:8}}>📝 Observaciones técnicas</div>
            <textarea value={reportTxt} onChange={e=>setReportTxt(e.target.value)} placeholder="Describe el estado de la obra, materiales observados, técnica utilizada, recomendaciones y cualquier observación relevante..." rows={4}
              style={{width:"100%",background:C.surface,border:`1.5px solid ${C.border}`,borderRadius:12,color:C.text,padding:"12px 14px",fontSize:13,resize:"none",boxSizing:"border-box",outline:"none",fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",lineHeight:1.6}}
              onFocus={e=>e.target.style.borderColor=C.blue} onBlur={e=>e.target.style.borderColor=C.border}/>
          </div>

          {/* Dictamen */}
          <div style={{marginBottom:14}}>
            <div style={{color:C.sub,fontSize:11,fontWeight:700,letterSpacing:0.8,textTransform:"uppercase",marginBottom:8}}>⚖️ Dictamen final</div>
            <div style={{display:"flex",flexDirection:"column",gap:8}}>
              {[["aprobada",C.green,"✅","Obra aprobada","Trabajo conforme, sin observaciones mayores."],["observaciones","#F57F17","⚠️","Con observaciones","Requiere correcciones menores antes de continuar."],["rechazada",C.red,"❌","No aprobada","Trabajo no conforme. Debe rehacerse antes de continuar."]].map(([val,color,icon,title,desc])=>(
                <div key={val} onClick={()=>setDictamen(val)} style={{background:dictamen===val?`${color}10`:C.surface,border:`1.5px solid ${dictamen===val?color:C.border}`,borderRadius:12,padding:"12px 14px",cursor:"pointer",display:"flex",gap:12,alignItems:"center",transition:"all 0.15s"}}>
                  <span style={{fontSize:22}}>{icon}</span>
                  <div>
                    <div style={{color:dictamen===val?color:C.text,fontSize:13,fontWeight:700}}>{title}</div>
                    <div style={{color:C.muted,fontSize:11}}>{desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Evidencia fotográfica */}
          <div style={{marginBottom:14}}>
            <div style={{color:C.sub,fontSize:11,fontWeight:700,letterSpacing:0.8,textTransform:"uppercase",marginBottom:4}}>📷 Evidencia fotográfica</div>
            <div style={{color:C.muted,fontSize:11,marginBottom:8}}>Mínimo 3 fotos obligatorias — general, detalle y condición relevante.</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10}}>
              {[["Vista general","🏗️"],["Detalle de obra","🔍"],["Condición relevante","📌"]].map(([label,icon],i)=>(
                <div key={i} onClick={()=>setFotos(f=>{const n=[...f];n[i]=!n[i];return n;})}
                  style={{height:88,borderRadius:12,border:`1.5px dashed ${fotos[i]?C.green:C.border}`,background:fotos[i]?C.greenL:C.surface,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",cursor:"pointer",transition:"all 0.2s"}}
                  onMouseEnter={e=>!fotos[i]&&(e.currentTarget.style.borderColor=C.blue)}
                  onMouseLeave={e=>!fotos[i]&&(e.currentTarget.style.borderColor=C.border)}>
                  <span style={{fontSize:fotos[i]?20:22,marginBottom:4}}>{fotos[i]?"✅":icon}</span>
                  <span style={{color:fotos[i]?C.green:C.muted,fontSize:9,textAlign:"center",padding:"0 4px",fontWeight:fotos[i]?700:400}}>{fotos[i]?"Cargada":label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Advertencia firma */}
          <div style={{background:"#FFFDE7",border:`1px solid #F9A82540`,borderRadius:12,padding:"12px 14px",marginBottom:16}}>
            <div style={{color:"#795548",fontWeight:700,fontSize:12,marginBottom:4}}>✍️ Firma digital del supervisor</div>
            <div style={{color:"#795548",fontSize:12,lineHeight:1.5}}>Al firmar confirmas que la información es verídica y que realizaste la visita en sitio. Tu cédula SEP queda vinculada a este documento. <strong>El reporte no puede modificarse después de firmado.</strong></div>
          </div>

          <Btn full color={C.blue} onClick={()=>{
            const checklistCompleto = Object.values(checklist).every(v=>v!==null);
            if(reportTxt.trim() && avance && dictamen && fotos.every(Boolean) && checklistCompleto) setSupFirmado(true);
          }}>✍️ Firmar reporte como supervisor</Btn>
          <div style={{color:C.muted,fontSize:11,textAlign:"center",marginTop:8}}>Debes completar todos los campos, el checklist, el dictamen y las 3 fotos para firmar.</div>
        </>
      ) : (
        // ── PASO 2: CLIENTE VALIDA ──
        <>
          <div style={{background:C.greenL,border:`1.5px solid ${C.green}30`,borderRadius:12,padding:"10px 14px",marginBottom:16,display:"flex",gap:8,alignItems:"center"}}>
            <span style={{fontSize:20}}>✅</span>
            <div>
              <div style={{color:C.green,fontWeight:700,fontSize:12}}>Paso 2 de 2 — Validación del Cliente</div>
              <div style={{color:C.sub,fontSize:11}}>El supervisor ya firmó. Ahora el cliente debe validar para cerrar el reporte.</div>
            </div>
          </div>

          {/* Resumen firmado por supervisor */}
          <div style={{background:C.surface,border:`1.5px solid ${C.green}40`,borderRadius:14,padding:16,marginBottom:14,boxShadow:"0 2px 6px rgba(0,0,0,0.04)"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
              <div style={{color:C.sub,fontSize:11,fontWeight:700,letterSpacing:0.8,textTransform:"uppercase"}}>Reporte firmado por</div>
              <Chip text="✍️ Firmado" color={C.blue} small/>
            </div>
            {[["Supervisor",selected?.name||"Ing. José Martínez"],["Avance",avance],["Dictamen",dictamen==="aprobada"?"✅ Obra aprobada":dictamen==="observaciones"?"⚠️ Con observaciones":"❌ No aprobada"],["Observaciones",reportTxt.slice(0,60)+(reportTxt.length>60?"...":"")]].map(([k,v])=>(
              <div key={k} style={{display:"flex",gap:12,marginBottom:8,paddingBottom:8,borderBottom:`1px solid ${C.divider}`}}>
                <span style={{color:C.muted,fontSize:12,minWidth:120}}>{k}</span>
                <span style={{color:C.text,fontSize:12,fontWeight:600,flex:1}}>{v}</span>
              </div>
            ))}
            <div style={{display:"flex",gap:8,marginTop:4}}>
              {fotos.map((f,i)=><div key={i} style={{flex:1,height:48,background:C.greenL,borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center",fontSize:16}}>{f?"✅":"📷"}</div>)}
            </div>
          </div>

          <div style={{background:C.blueL,border:`1.5px solid ${C.blue}30`,borderRadius:12,padding:"12px 14px",marginBottom:14}}>
            <div style={{color:C.blue,fontWeight:700,fontSize:12,marginBottom:4}}>👤 ¿Estás de acuerdo con este reporte?</div>
            <div style={{color:C.sub,fontSize:12,lineHeight:1.5}}>Al validar, el reporte queda cerrado y con validez oficial. Tienes <strong>24 horas</strong> para objetar antes de que se cierre automáticamente.</div>
          </div>

          <div style={{background:"#FFFDE7",border:`1px solid #F9A82540`,borderRadius:12,padding:"12px 14px",marginBottom:16}}>
            <div style={{color:"#795548",fontWeight:700,fontSize:12,marginBottom:4}}>✍️ Firma digital del cliente</div>
            <div style={{color:"#795548",fontSize:12}}>Al firmar como cliente confirmas que estuviste presente o tienes conocimiento de la visita realizada. El reporte quedará cerrado permanentemente.</div>
          </div>

          <div style={{display:"flex",flexDirection:"column",gap:10}}>
            <Btn full color={C.green} onClick={()=>setReportDone(true)}>✍️ Validar y cerrar reporte</Btn>
            <Btn full outline color={C.red} onClick={()=>window.ficioToast?.("Comunica tu objeción directamente al supervisor por el chat.", "info")}>⚠️ Tengo una objeción</Btn>
          </div>
          <div style={{color:C.muted,fontSize:11,textAlign:"center",marginTop:8}}>Si tienes una objeción, Ficio abre un proceso de mediación antes de cerrar el reporte.</div>
        </>
      )}
    </div>
  );

  return null;
};
